var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMisReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3542 16.4875C18.749 22.6625 10.275 24.4625 5.41772 19.65C0.656265 14.9313 2.13022 6.38546 8.39272 3.64587",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4198 13.0209C20.3865 13.0209 21.3698 13.0209 22.0042 12.1407C22.0281 12.1073 22.0667 12.049 22.0886 12.0146C22.6594 11.0907 22.3656 10.3813 21.7771 8.96255C21.2442 7.67581 20.463 6.50666 19.4782 5.52185C18.4934 4.53704 17.3243 3.75588 16.0375 3.22297C14.6188 2.63443 13.9094 2.34067 12.9854 2.91047C12.9511 2.93234 12.8917 2.97297 12.8594 2.99588C11.9792 3.6313 11.9792 4.61359 11.9792 6.57922V8.77817C11.9792 10.7782 11.9792 11.7782 12.6 12.4C13.2219 13.0209 14.2219 13.0209 16.2209 13.0209H18.4198Z",
    stroke: "#1B385F",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisReport);
export default __webpack_public_path__ + "static/media/MIS Report.d395c197104f724e2545aa926d70a0a1.svg";
export { ForwardRef as ReactComponent };